
export enum AlignmentBaseline {
  middle = 'middle',
  handing = 'hanging',
}

const fontSize = 16;
// This is empirical measurement:
// A quarter of the font size is whitespace above and below the actual text:
const textVerticalMargin = 0.25 * fontSize;

const textOnlyHeight = fontSize - 2 * textVerticalMargin;

export type AlignmentBaselineInput = 'middle' | 'hanging';
export type AlignmentBaselineOutput = 'middle' | 'hanging' | 'auto';

interface IOutput {
  y: number;
  alignmentBaseline: AlignmentBaselineOutput;
}

// This adapts vertical text alignment depending on whether manual y-positioning
// is needed to vertically center text e.g. in SVG, `alignment-baseline` works
// so we don't need to do any manual positioning but for SVG that will be
// converted to PDF, `alignment-baseline` doesn't work so we need to adjust the
// positiion manually.
const adjustVerticalTextAlignmentInfo = (
    needAdjustment: boolean,
    desiredY: number,
    desiredAlignmentBaseline: AlignmentBaselineInput): IOutput => {

  if (needAdjustment) {
    if (desiredAlignmentBaseline === 'middle') {
      return {
        y: desiredY + textOnlyHeight / 2,
        alignmentBaseline: 'auto',
      };
    } else {
      return {
        y: desiredY + textOnlyHeight,
        alignmentBaseline: 'auto',
      };
    }
  } else {
    return {
      y: desiredY,
      alignmentBaseline: desiredAlignmentBaseline,
    };
  }
};

export default adjustVerticalTextAlignmentInfo;
